module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/about-banner.jpg"),
      "alt": "aboutbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v("关于我们")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 contleft"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('nav', {
    attrs: {
      "id": "sidebar"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "leftNav"
  }, [_c('ul', {
    staticClass: "list-unstyled components"
  }, _vm._l((_vm.menuList), function(list, index) {
    return _c('li', [(list.children != undefined && list.children != null && list.children != '') ? _c('div', [_c('a', {
      staticClass: "dropdown-toggle leftNavCur",
      attrs: {
        "href": '#submenu' + index,
        "data-toggle": "collapse",
        "aria-expanded": "false"
      }
    }, [_vm._v(_vm._s(list.menuName))]), _vm._v(" "), _c('ul', {
      staticClass: "collapse list-unstyled",
      attrs: {
        "id": 'submenu' + index
      }
    }, _vm._l((list.children), function(sublist, subindex) {
      return _c('li', [_c('a', {
        staticClass: "leftNavCur2",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(" - " + _vm._s(sublist.menuName))])])
    }), 0)]) : _c('div', [_c('a', {
      key: index,
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.getInfo(list.id)
        }
      }
    }, [_vm._v(_vm._s(list.menuName))])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 contright"
  }, [_c('h2', {
    staticClass: "rightTitle"
  }, [_vm._v(_vm._s(_vm.aboutInfo.menuName))]), _vm._v(" "), _c('div', {
    staticClass: "Article"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutInfo.dscr)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clears"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-header"
  }, [_c('h2', {
    staticClass: "leftTitle"
  }, [_vm._v("关于我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c564cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 300
// module chunks = 2